import 'handsontable';
import HandsontableFunctions from './handsontableFunctions.js';

const HandsontableControls = {
	init: function () {
		// Check if handsontable controls are present
		if ($('#handsontableControls').length) {
			// Bind Add Row button aan functie
			$('#addRow').on('click', function () {
				HandsontableFunctions.addRow(window.app.hot);
			});

			// Bind Remove Row button to remove row function
			$('#removeRow').on('click', function () {
				HandsontableFunctions.removeRow(window.app.hot);
			});

			// Bind export button to export function
			$('#exportcsv').on('click', function () {
				window.app.hot.getPlugin('exportFile').downloadFile('csv', {
					filename: 'export_gegevens',
					columnHeaders: true,
					columnDelimiter: ';',
				});
			});

			// Bind import button to upload field
			$('#importcsv').on('click', function () {
				$('input#importFile[type=file]').prop('value', '').trigger('click');
			});

			// Bind undo button
			$('#undo').on('click', function () {
				HandsontableFunctions.undo(window.app.hot);
			});

			// Bind redo button to redo function
			$('#redo').on('click', function () {
				HandsontableFunctions.redo(window.app.hot);
			});

			// Bind undo button to undo function
			$('#empty').on('click', function () {
				window.app.hot.updateSettings({
					data: [],
				});
			});

			// Bind redo button to fill function
			$('#fill').on('click', function () {
				window.app.hot.updateSettings({
					data: JSON.parse(window.hotEl.getAttribute('data-data')),
				});
			});

			// Bind upload field to PapaParse
			$('input#importFile[type=file]').on('change', function (element) {
				HandsontableFunctions.importData(element);
			});
		}
	},
};

export default HandsontableControls;
